import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useMap } from '@vis.gl/react-google-maps';

interface MapPortalProps {
  children: React.ReactNode;
}

const MapPortal: React.FC<MapPortalProps> = ({ children }) => {
  const map = useMap();
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!map) return;

    const mapElement = map.getDiv();

    if (mapElement) {
      setContainer(mapElement as HTMLElement);
    }
  }, [map]);

  return container ? createPortal(children, container) : null;
};

export default MapPortal;
